interface UserManagementAppConfig {
  USER_MANAGEMENT_API_URL: string;
  PORTAL_API_URL: string;
  IDENTITY_SERVER_URL: string;
  PORTAL_URL: string;
  APP_CLIENT_COOKIE_NAME: string;
  AMPLITUDE_API_KEY: string;
  ENVIRONMENT: string;
  SIGNUP_URL: string;
  DATADOG_PRIVACY_LEVEL: "allow" | "mask-user-input" | "mask";
  AUTH0_DOMAIN: string;
  AUTH0_CLIENTID: string;
  TURNSTILE_SITE_KEY: string;
  DEFAULT_TO_AUTH0: string;
}

interface ConfigWindow extends Window {
  UserManagementAppConfig: UserManagementAppConfig;
}

declare let window: ConfigWindow;

const config: UserManagementAppConfig = window.UserManagementAppConfig || {
  USER_MANAGEMENT_API_URL: "https://users-api-integration.codat.io",
  PORTAL_API_URL: "https://portal-api-integration.codat.io",
  IDENTITY_SERVER_URL: "https://identity-integration.codat.io",
  PORTAL_URL: "https://app-integration.codat.io",
  APP_CLIENT_COOKIE_NAME: "app-integration-clientid",
  AMPLITUDE_API_KEY: "1c2a84301c15f56221a6f81af617f5f7",
  ENVIRONMENT: "Integration",
  SIGNUP_URL: "https://signup-integration.codat.io",
  DATADOG_PRIVACY_LEVEL: "allow",
  AUTH0_DOMAIN: "authentication-integration.codat.io",
  AUTH0_CLIENTID: "ZI6Rwgk2imDGDZ82PCQkLHJrZitJODOr",
  TURNSTILE_SITE_KEY: "0x4AAAAAAAzX-wINkvw2C3KM",
  DEFAULT_TO_AUTH0: "true",
};

export default config;
